// utils/handleApiError.js
export function handleApiError(response, t) {
  let errorResponse = {
    isError: false,
    errorMessage: 'An unexpected error occurred.',
  };

  const status = typeof response === 'object' && response?.status != null ? response.status : response;
  const errorMessages = {
    500: t('error.server-unreachable'),
    422: t('error.data-validation-error'),
    409: t('error'),
    404: t('error.not-found'),
    403: t('error.unauthorized'),
    401: t('error.unauthenticated'),
    400: t('error.bad-request'),
    429: t('error.too-many-requests'),
  };

  switch (status) {
    case 500:
    case 422:
    case 409:
    case 404:
    case 403:
    case 401:
    case 400: {
      const fallbackMessage = errorMessages[status] || 'An unexpected error occurred.';
      errorResponse.isError = true;
      errorResponse.errorMessage = fallbackMessage;
      break;
    }
    case 429: {
      const fallbackMessage =
        (typeof response === 'object' && response?.message) || errorMessages[429] || 'Too many requests. Please try again later.';
      errorResponse.isError = true;
      errorResponse.errorMessage = fallbackMessage;
      break;
    }
    default:
      break;
  }

  // On 401 clear session storage; do not reload so app can show error and handle auth state
  if (status === 401) {
    sessionStorage.clear();
  }

  return errorResponse;
}
